import { OperatingSystem } from "./operating-system.enum"

const macosPlatforms = ["Mac", "Macintosh", "MacIntel", "MacPPC", "Mac68K"]
const windowsPlatforms = ["Windows", "Win32", "Win64", "WinCE"]
const iosPlatforms = ["iPhone", "iPad", "iPod"]

const resolveOperatingSystem = () => {
  const userAgent = typeof window !== "undefined" && window.navigator.userAgent
  const platform = typeof window !== "undefined" && window.navigator.platform

  if (platform && userAgent) {
    if (macosPlatforms.includes(platform)) {
      return OperatingSystem.MacOS
    } else if (windowsPlatforms.includes(platform)) {
      return OperatingSystem.Windows
    } else if (iosPlatforms.includes(platform)) {
      return OperatingSystem.iOS
    } else if (/Android/i.test(userAgent)) {
      return OperatingSystem.Android
    } else if (/Linux/i.test(platform)) {
      return OperatingSystem.Linux
    } else {
      return OperatingSystem.Unknown
    }
  } else {
    return OperatingSystem.Unknown
  }
}

export default resolveOperatingSystem
